import { render } from "./NotificationsView.vue?vue&type=template&id=580146c0&scoped=true&ts=true"
import script from "./NotificationsView.vue?vue&type=script&lang=ts"
export * from "./NotificationsView.vue?vue&type=script&lang=ts"

import "./NotificationsView.vue?vue&type=style&index=0&id=580146c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580146c0"]])

export default __exports__